import React from "react";

const Integrations = () => {
    return (
        <>
            This is Integrations Page
        </>
    );
};

export default Integrations;
